import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import store from "./store/store";
import { Provider } from "react-redux";
// import "react-phone-input-2/lib/style.css";
import { FirebaseProvider } from "./firebase/firebase";

ReactDOM.render(
  <FirebaseProvider>
  <BrowserRouter>
    <Provider store={store}>
      <ToastContainer />
      <App />
      <ScrollToTop />
    </Provider>
  </BrowserRouter>
  </FirebaseProvider>,
  document.getElementById("root")
);
